export default __webpack_public_path__ + "static/election-59d4943d5fb127e29c86ff006f1184e6.png";